var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.39 228.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11{fill:#1c2c58;}.cls-12,.cls-2{fill:#d1a782;}.cls-3{fill:#956f51;}.cls-4{fill:#e1dfe1;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-4,.cls-5,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-5{fill:#f3d3bc;}.cls-6{opacity:0.35;}.cls-7{fill:#9f7555;}.cls-8{fill:#fdede3;}.cls-9{fill:#eb2025;}.cls-10{fill:#dcd4c9;}.cls-13{fill:#edc6a9;}.cls-14{fill:#fff6e9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "speed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.71.05A24.18,24.18,0,1,0,120.32,25.7,24.17,24.17,0,0,0,97.71.05ZM96.2,42.21a18,18,0,1,1,18-18A18,18,0,0,1,96.2,42.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.14,44a6,6,0,0,1,1.14-3.5V33.92H88.63v6.52a5.82,5.82,0,0,1,0,6.92v1.2h14.65V47.48A6,6,0,0,1,102.14,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.63,32.11H85.27a1.81,1.81,0,0,0,1.81,1.81h17.74a1.81,1.81,0,0,0,1.81-1.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.05,
    y: 19.35,
    width: 23.79,
    height: 12.76,
    rx: 2.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.86,19.35H85a1.84,1.84,0,0,1,1.84-1.84H105a1.84,1.84,0,0,1,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.2,199c53.12,0,96.19,6.63,96.19,14.8s-43.07,14.8-96.19,14.8S0,222,0,213.81,43.07,199,96.2,199"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.2,73.86a58.52,58.52,0,1,1-58.53,58.52A58.52,58.52,0,0,1,96.2,73.86"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.55,97.47h0a1,1,0,0,1,1.46,0l34.82,34.81a1,1,0,0,1,0,1.47h0a1,1,0,0,1-1.47,0L63.55,98.93a1,1,0,0,1,0-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.07,151.58c13.21-3.08,20-8.7,30-16.62l-1.34-2.21c-11.64,5.19-19.75,8.56-28.61,18.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.35,85.74c-4.2,18-2.89,30.07-1.29,47.69h2.59c1.59-17.62,2.91-29.72-1.3-47.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.35,127.55A6.31,6.31,0,1,1,92,133.86a6.3,6.3,0,0,1,6.31-6.31"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.2,73.86a58.24,58.24,0,0,1,35.86,12.28A60,60,0,0,0,56.8,175.65,58.51,58.51,0,0,1,96.2,73.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.47,96.38h0a1,1,0,0,1,1.47,0l34.82,34.81a1.05,1.05,0,0,1,0,1.47h0a1,1,0,0,1-1.47,0L60.47,97.85a1.05,1.05,0,0,1,0-1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.26,131.06a2.76,2.76,0,1,0,2.76,2.76,2.75,2.75,0,0,0-2.76-2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.91,150.1c13.21-3.08,20-8.7,30-16.62l-1.34-2.21c-11.65,5.19-19.76,8.56-28.62,18.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.2,84.27c-4.21,18-2.89,30.07-1.3,47.68h2.59c1.59-17.61,2.91-29.72-1.29-47.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.2,126.07a6.31,6.31,0,1,1-6.32,6.31,6.31,6.31,0,0,1,6.32-6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.2,129.62A2.76,2.76,0,1,0,99,132.38a2.75,2.75,0,0,0-2.75-2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.2,53.76a78.62,78.62,0,1,1-78.63,78.62A78.62,78.62,0,0,1,96.2,53.76m0-5.61A84.23,84.23,0,1,1,12,132.38,84.24,84.24,0,0,1,96.2,48.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.2,66.26A66.13,66.13,0,1,1,49.45,85.63,65.91,65.91,0,0,1,96.2,66.26m0-12.5a78.62,78.62,0,1,1-78.63,78.62A78.62,78.62,0,0,1,96.2,53.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M96.2,53.76q-1.94,0-3.84.09a78.62,78.62,0,0,1,0,157.06q1.9.09,3.84.09a78.62,78.62,0,0,0,0-157.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M80.91,209.51a78.63,78.63,0,0,1,0-154.26,80.06,80.06,0,0,0,0,154.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.53,
    y: 71.61,
    width: 3.32,
    height: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.59,91a58.54,58.54,0,1,0,17.15,41.4A58.36,58.36,0,0,0,137.59,91M96.2,66.26A66.13,66.13,0,1,1,49.45,85.63,65.91,65.91,0,0,1,96.2,66.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.23,
    y: 82.91,
    width: 11.13,
    height: 3.32,
    transform: "translate(-11.32 149.54) rotate(-60.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.43,
    y: 103.12,
    width: 11.14,
    height: 3.32,
    transform: "translate(-33.09 86.01) rotate(-29.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.83,
    y: 130.72,
    width: 11.14,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.34,
    y: 154.41,
    width: 3.32,
    height: 11.14,
    transform: "translate(-66.54 204.73) rotate(-60.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.14,
    y: 174.62,
    width: 3.32,
    height: 11.13,
    transform: "translate(-73.48 85.97) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.54,
    y: 182.01,
    width: 3.32,
    height: 11.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.03,
    y: 178.52,
    width: 11.14,
    height: 3.32,
    transform: "translate(-121.76 149.58) rotate(-60.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.82,
    y: 158.32,
    width: 11.14,
    height: 3.32,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -73.54, 45.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.43,
    y: 130.72,
    width: 11.13,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.73,
    y: 99.21,
    width: 3.32,
    height: 11.13,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -66.54, 94.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.93,
    y: 79.01,
    width: 3.32,
    height: 11.14,
    transform: "translate(-33.08 45.58) rotate(-29.97)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.daec5b0e0ab7b92cfb506c6857d43f44.svg";
export { ForwardRef as ReactComponent };